import { Stack, Typography } from '@mui/material';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';
import { translateBlock } from 'i18n';
import type { CatalogTreeField } from 'modules/datacatalog/types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import routes from '../../../routes';
import DataTypeIcon from '../../DataTypeIcon/DataTypeIcon';

const TableFields = ({ fields }: { fields: CatalogTreeField[] }) => {
    const { t } = useTranslation();

    return (
        <Stack spacing={0.25} sx={{ mt: 4, mb: 4 }}>
            <Stack direction="row" sx={{ alignItems: 'center' }}>
                <Typography variant="h5" color="textPrimary">
                    {t('dataCatalog.fields')}
                </Typography>
            </Stack>
            {fields
                .filter(({ type }) => type !== 'table')
                .map((field) => (
                    <Stack
                        key={field.field}
                        component={Link}
                        to={`${routes.dataCatalog}?field=${encodeURIComponent(field.field)}`}
                        direction="row"
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            textDecoration: 'none',
                            color: 'inherit',
                            '&:hover': { bgcolor: 'action.hover' },
                        }}
                    >
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{ alignItems: 'center' }}
                        >
                            <DataTypeIcon type={field.type} />
                            <Typography variant="body2">
                                {capitalizeAndKeepTheRest(
                                    translateBlock(field.field),
                                )}
                            </Typography>
                        </Stack>
                        <Typography variant="caption" color="textDisabled">
                            {t(`dataCatalog.${field.type}`)}
                        </Typography>
                    </Stack>
                ))}
        </Stack>
    );
};

export default TableFields;
